import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';

import { DEFAULT_MASTER_DRAWER_WIDTH } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import CustomTableSearch from "../../common/CustomTableSearch";

import generalCustomerService from "../../../api/general.customer.service";
import GeneralCustomerEntry from "./GeneralCustomerEntry";



const GeneralCustomerList = () => {

  const dispatch = useDispatch();  
  const state = useSelector((state)=>state.customer)
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  

  const [visible, setVisible] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerData, setCustomerData] = useState({
      customer_id: 0,     
      customer_name: '',    
      address:'',    
      gstin_no:'',
      pan_no:'',
      mobile_no:'',
});

  const showDrawer = (rowdata) => {  
 //   setProgrammeCommercialData(_);    

 setCustomerData({
      customer_id: rowdata.customer_id,     
      customer_name: rowdata.customer_name,
      address:rowdata.address,
      gstin_no:rowdata.gstin_no,
      pan_no:rowdata.pan_no,
      mobile_no:rowdata.mobile_no,   
      mode: "EDIT"
  })

    setVisible(true);

  };


  const onClose = () => {
    setVisible(false);
  };
 
  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: (a, b) => a.customer_name.localeCompare(b.customer_name),
    },
   
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    //   sorter: (a, b) => a.address.localeCompare(b.address),
    }, 
    {
        title: 'Mobile No.',
        dataIndex: 'mobile_no',
        key: 'mobile_no',       
    },   
    {
        title: 'GSTIN',
        dataIndex: 'gstin_no',
        key: 'gstin_no',       
    },    
    {
        title: 'PAN',
        dataIndex: 'pan_no',
        key: 'pan_no',       
    },   
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    generalCustomerService.list().then((res) => {
      setCustomerList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [state.customer])


  const onSearch = (e) => {
    const searchString = e.target.value.toLowerCase();
    const filteredList = customerList.filter(data => {  
        const dataString = JSON.stringify(data).toLowerCase();       
        const isDataStringMatch = dataString.includes(searchString);    
        return isDataStringMatch;
    });
    setFilteredSearchList(filteredList);
}

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch}  />
      <Table 
        columns={columns} 
        rowKey='customer_id' 
        dataSource={filteredSearchList} 
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
        />

      <Drawer
          title="Edit Customer"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <GeneralCustomerEntry data={customerData} onDrawerClose={onClose}   />
        </Drawer>

    </>
  );
};

export default GeneralCustomerList;